import {
  parseDetailedMessage,
  toKeyedProblems,
  toKeyedTokens
} from '~/shared/components/Notifications/DetailedErrorMessage/helpers'

const ProblemLine = ({ problem }: { problem: string }) => (
  <>
    {toKeyedTokens(problem).map(({ key, value, isCode }) => isCode ?
      <code
        key={key}
        className="px-1 font-semibold break-all"
      >
        {value}
      </code> :
      <span key={key}>{value}</span>
    )}
  </>
)

export const DetailedErrorMessage = ({ message }: { message: string }) => {
  const { summary, problems } = parseDetailedMessage(message)

  if (!summary) {
    return null
  }

  return (
    <div data-testid="detailed-error-message">
      <p>{summary}</p>
      {problems.length > 0 &&
        <ul className="mt-2 flex list-disc flex-col gap-1.5 pl-4">
          {toKeyedProblems(problems).map(({ key, value }) => (
            <li key={key}>
              <ProblemLine problem={value} />
            </li>
          ))}
        </ul>
      }
    </div>
  )
}
